export default __webpack_public_path__ + "static/media/certificate_5.d8ded8a9.png";